/** 배열을 지정 크기 단위로 나눕니다. (대량 발송 API 분할 요청용) */
export function chunkArray<T>(array: T[], size: number): T[][] {
  if (size < 1) return [array];
  const chunks: T[][] = [];
  for (let i = 0; i < array.length; i += size) {
    chunks.push(array.slice(i, i + size));
  }
  return chunks;
}
